/* Lightweight, section-local behavior. No dependencies or network requests. */
if (!customElements.get('lm-order-guide')) {
  customElements.define('lm-order-guide', class extends HTMLElement {
    connectedCallback() {
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.syncMotion = () => this.classList.toggle('is-visible', this.inView && !this.motionQuery.matches && !document.hidden);
      this.motionQuery.addEventListener('change', this.syncMotion);
      document.addEventListener('visibilitychange', this.syncMotion);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.syncMotion();
        });
        this.observer.observe(this);
      }
      this.onStart = (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('[data-lm-how-start]');
        if (!link) return;
        const productInfo = document.querySelector(link.getAttribute('href'));
        const upload = productInfo && productInfo.querySelector('[data-lm-upload]');
        if (!upload) return;
        event.preventDefault();
        const top = upload.getBoundingClientRect().top + window.scrollY - Math.min(window.innerHeight * 0.3, 220);
        window.scrollTo({top: Math.max(0, top), behavior: this.motionQuery.matches ? 'instant' : 'smooth'});
        upload.focus({preventScroll: true});
      };
      this.addEventListener('click', this.onStart);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.motionQuery) this.motionQuery.removeEventListener('change', this.syncMotion);
      document.removeEventListener('visibilitychange', this.syncMotion);
      this.removeEventListener('click', this.onStart);
    }
  });
}
